import React from "react";
import { useSelector } from "react-redux";
import {
	selectAssetCriticalityScore,
	selectOverallRiskConsequences,
	selectOverallRiskScore,
} from "reducers";

const SQUARE_WIDTH = 35;

const RISK_COLORS = {
	1: "forestgreen",
	2: "yellowgreen",
	3: "yellow",
	4: "orange",
	5: "red",
};

const CRITICALITY_DESCRIPTIONS = {
	1: "1 - Very Low Criticality",
	2: "2 - Low Criticality",
	3: "3 - Moderate Criticality",
	4: "4 - High Criticality",
	5: "5 - Very High Criticality",
};

const RISK_DESCRIPTIONS = {
	1: "Very Low Risk",
	2: "Low Risk",
	3: "Medium Risk",
	4: "High Risk",
	5: "Very High Risk",
};

const ColoredSquare = ({ score }) => {
	const color = RISK_COLORS[score];
	return (
		<div
			style={{
				height: SQUARE_WIDTH,
				width: SQUARE_WIDTH,
				backgroundColor: color,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			{score}
		</div>
	);
};

const Legend = () => {
	return (
		<div style={{ display: "flex" }}>
			<ColoredSquare score={1} />
			<ColoredSquare score={2} />
			<ColoredSquare score={3} />
			<ColoredSquare score={4} />
			<ColoredSquare score={5} />
		</div>
	);
};

const Risk = ({ type, score, calculatedScore }) => {
	return (
		<div
			style={{
				width: SQUARE_WIDTH * 5,
				height: SQUARE_WIDTH * 2,
				backgroundColor: RISK_COLORS[score],
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
				fontWeight: 600,
				padding: 10,
			}}
		>
			{type === "assetCriticality"
				? CRITICALITY_DESCRIPTIONS[score]
				: calculatedScore + " - " + RISK_DESCRIPTIONS[score]}
		</div>
	);
};

const RiskMatrix = ({ type, score, calculatedScore }) => {
	return score !== 0 ? (
		<>
			<Legend />
			<Risk type={type} score={score} calculatedScore={calculatedScore} />
		</>
	) : (
		<></>
	);
};

export const AssetCriticality = () => {
	const score = useSelector(selectAssetCriticalityScore);
	return <RiskMatrix type="assetCriticality" score={score} />;
};

export const OverallRiskAssetFailure = () => {
	const score = useSelector(selectOverallRiskScore);
	const convertedScore =
		score === 0 ? 0 : score <= 3 ? 2 : score <= 6 ? 3 : score <= 12 ? 4 : 5;

	return (
		<RiskMatrix
			type="overallRisk"
			score={convertedScore}
			calculatedScore={score}
		/>
	);
};

export const OverallRiskConsequences = () => {
	const score = useSelector(selectOverallRiskConsequences);

	const convertedScore =
		score === 0 ? 0 : score <= 3 ? 2 : score <= 6 ? 3 : score <= 12 ? 4 : 5;

	return (
		<RiskMatrix
			type="overallRisk"
			score={convertedScore}
			calculatedScore={convertedScore}
		/>
	);
};
